<template>
    <div class="sr-edit-table">
        <el-table
            header-cell-class-name="gery_bgc"
            :cell-class-name="getCellClass"
            :data="tableConfig.data"
            border
            :show-summary="tableConfig.showSummary"
            :span-method="tableConfig.spanMethod"
            :sum-text="tableConfig.sumText"
            :summary-method="tableConfig.summaryMethod"
            style="width: 100%"
        >
            <el-table-column
                v-for="item in tableConfig.header"
                :key="item.prop"
                :index="item.index"
                :column-key="item.editProp"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
            >
                <template slot-scope="scope">
                    <!-- 自定义插槽 -->
                    <slot
                        name="cellSlot"
                        v-if="item.cellSlot"
                        :scope="{ row: scope.row, item: item, index: item.index }"
                    ></slot>
                    <!-- 录入 -->
                    <div v-else-if="item.index === 1 && edit && !scope.row[item.editProp]">
                        <el-input v-model="scope.row[item.prop]" :placeholder="scope.row[item.placeholderProp] || item.placeholder" :type="item.type"></el-input>
                    </div>
                    <!-- 录入的内容查看 -->
                    <span v-else-if="item.index === 1 && !item.hidPopover">
                        <el-popover
                            placement="top-start"
                            trigger="hover"
                            :width="item.popoverWidth"
                            :content="scope.row[item.prop]"
                        >
                            <div slot="reference">{{scope.row[item.prop]}}</div>
                        </el-popover>
                    </span>
                    <!-- 标题展示 -->
                    <span v-else>{{scope.row[item.prop]}}</span>
                </template>
            </el-table-column>

            <slot name="empty" slot="empty"></slot>
        </el-table>
    </div>
</template>

<script>
export default {
    name: "SrEditTable",
    props: {
        tableConfig: {
            type: Object,
            default: () => {
                return {
                    data: [
                        {
                            date: "2016-05-02",
                            name: "王小虎",
                            address: "上海市普陀区金沙江路 1518 弄",
                        },
                    ],
                    header: [
                        {
                            label: "指标",
                            prop: "name",
                        },
                        {
                            label: "指标说明",
                            prop: "address",
                            index: 0,
                        },
                    ],
                    showSummary: false,
                    sumText: "小计",
                };
            },
        },
        edit: {
            type: Boolean,
            default: () => {
                return true;
            },
        },
    },
    data() {
        return {};
    },
    methods: {
        getCellClass({ row, column, rowIndex, columnIndex }) {
            if (!this.edit) {
                return ''
            }
            if (column.index !== 1) {
                return "gery_bgc";
            }
            if (this.tableConfig.header[columnIndex]) {
                const editProp = this.tableConfig.header[columnIndex].editProp;
                if (editProp) {
                    if (row[editProp]) {
                        return "gery_bgc";
                    }
                }
            }
            
        },
    },
};
</script>


// WEBPACK FOOTER //
// packages/SrEditTable/index.vue